<div id="drug-summary">
  <app-ark-container
    [future]="dataObservable"
    [loadingTemplate]="loading"
    [successTemplate]="success"
    [failureTemplate]="failure"
    [errorTemplate]="error"
    (onSuccess)="onDrugSummaryDataResolved($event[0])"
  >
  </app-ark-container>

  <ng-template #loading>
    <div nz-row nzType="flex" [nzGutter]="16">
      <div nz-col nzSpan="12">
        <va-custom-skeleton [customSkeletonConfig]="customSkeletonConfig">
        </va-custom-skeleton>
      </div>
      <div nz-col nzSpan="12">
        <va-custom-skeleton [customSkeletonConfig]="customSkeletonConfig">
        </va-custom-skeleton>
      </div>
    </div>
  </ng-template>

  <ng-template #success>
    <div class="col-container">
      <div id="right-panel-overall-summary" class="container-shadow">
        <div>
          <div id="right-panel-heading">
            <span> Drug Name </span>
            <div class="peers-button">
              <va-button
                btnType="outline"
                size="small"
                nz-dropdown
                [nzBackdrop]="true"
                nzTrigger="click"
                [nzDropdownMenu]="menu"
              >
                View Peers
                <va-icon size="small" name="chevron-down"></va-icon>
              </va-button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li
                    *ngIf="data.data.indication_by_phase.length > 0"
                    nz-menu-item
                    (click)="onPeers('indication')"
                  >
                    View Peers by Indication
                  </li>
                  <li
                    *ngIf="data.data.moa.length > 0"
                    nz-menu-item
                    (click)="onPeers('moa')"
                  >
                    View Peers by MOA
                  </li>
                  <li
                    *ngIf="data.data.api.length > 0"
                    nz-menu-item
                    (click)="onPeers('api')"
                  >
                    View Peers by API
                  </li>
                  <li
                    *ngIf="data.data.target.length > 0"
                    nz-menu-item
                    (click)="onPeers('target')"
                  >
                    View Peers by Target
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>
          </div>
          <div class="drug-name">
            <span [title]="data.data.drug_name">{{ data.data.drug_name }}</span>
          </div>
        </div>
        <div class="summary-contents">
          <div class="right-panel-heading-spacing">
            <div id="right-panel-heading">
              <span>API</span>
            </div>
            <div class="right-panel-sub-headings">
              <span *ngIf="data.data.api.length === 0"> - </span>
              <ng-container *ngIf="data.data.api.length > 0">
                <span class="truncate" [title]="data.data.api[0]">
                  {{ data.data.api[0] }}
                </span>
                <span
                  *ngIf="data.data.api.length > 1"
                  style="margin-top: 4px; text-wrap: nowrap"
                >
                  <span
                    nz-dropdown
                    nzTrigger="click"
                    [nzDropdownMenu]="apiMenu"
                    (nzVisibleChange)="onApiVisibleChange($event)"
                    [nzBackdrop]="false"
                  >
                    <va-icon
                      *ngIf="apiDataVisible; else expand"
                      size="small"
                      name="collapse-arrows"
                      style="margin-left: 4px"
                    ></va-icon>
                    <ng-template #expand>
                      <va-icon
                        size="small"
                        name="expand-arrows"
                        style="margin-left: 4px"
                      ></va-icon>
                    </ng-template>
                  </span>
                  <nz-dropdown-menu #apiMenu="nzDropdownMenu">
                    <ul class="custom-dropdown" nz-menu>
                      <li
                        *ngFor="let item of data.data.api.slice(1)"
                        nz-menu-item
                        class="defaultCursor dropdown-items"
                      >
                        {{ item }}
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </span>
                <span *ngIf="data.data.api.length > 1">
                  (+{{ data.data.api.length - 1 }})
                </span>
              </ng-container>
            </div>
          </div>
          <div class="right-panel-heading-spacing">
            <div id="right-panel-heading">
              <span>Company</span>
            </div>
            <div class="right-panel-sub-headings">
              <span class="truncate" [title]="data.data.company"
                >{{ data.data.company }}
              </span>
              <span [title]="data.data.ticker">| ({{ data.data.ticker }})</span>
            </div>
          </div>
          <div class="right-panel-heading-spacing">
            <div id="right-panel-heading">
              <span>Therapeutic Area</span>
            </div>
            <div class="right-panel-sub-headings">
              <span class="truncate" [title]="data.data.therapeutic_area">{{
                data.data.therapeutic_area
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div id="left-panel-overall-summary" class="container-shadow">
        <div class="coll">
          <div id="indication-by-phase">
            <div class="left-panel-heading">
              <span>Indications by phase</span>
              <va-icon
                isFontAwesome="true"
                [name]="faFileSearch"
                [class]="
                  auditIconVisible.indications
                    ? 'formula-icon'
                    : 'formula-icon-disabled'
                "
                (click)="auditSource({}, 'indications', true)"
                [title]="
                  auditIconVisible.indications
                    ? 'Audit Source'
                    : 'Source Not Available'
                "
                *ngIf="data.data.indication_by_phase.length > 0"
              ></va-icon>
            </div>
            <div class="sub-headings">
              <ng-container *ngFor="let group of groupedIndications">
                <ng-container *ngIf="group.indications.length > 0">
                  <div class="phase-container">
                    <span class="phase-heading" [title]="group.phase">
                      {{ abbreviations[group.phase] || group.phase }}
                    </span>
                    <span style="margin-right: 8px">:</span>
                    <span
                      class="content indication-truncate"
                      [title]="group.indications[0]"
                    >
                      {{ group.indications[0] }}
                    </span>
                    <span
                      *ngIf="group.indications.length > 1"
                      style="text-wrap: nowrap"
                    >
                      <span class="content" style="margin-left: 4px"
                        >( +{{ group.count - 1 }})</span
                      >
                      <span
                        nz-dropdown
                        nzTrigger="click"
                        [nzDropdownMenu]="indicationMenu"
                        (nzVisibleChange)="
                          onMenuVisibleChange($event, group.phase)
                        "
                        [nzBackdrop]="false"
                      >
                        <va-icon
                          *ngIf="visible[group.phase]; else expand"
                          size="small"
                          name="collapse-arrows"
                          style="margin-left: 4px"
                        ></va-icon>
                        <ng-template #expand>
                          <va-icon
                            size="small"
                            name="expand-arrows"
                            style="margin-left: 4px"
                          ></va-icon>
                        </ng-template>
                      </span>
                      <nz-dropdown-menu #indicationMenu="nzDropdownMenu">
                        <ul nz-menu>
                          <li
                            class="defaultCursor dropdown-items dropdown-heading"
                          >
                            {{ abbreviations[group.phase] || group.phase }} ({{
                              group.count - 1
                            }})
                          </li>
                          <li
                            *ngFor="
                              let indication of group.indications.slice(1)
                            "
                            nz-menu-item
                            class="defaultCursor dropdown-items"
                          >
                            {{ indication }}
                          </li>
                        </ul>
                      </nz-dropdown-menu>
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <div class="divider"></div>
          <div id="moa">
            <div class="moa-conatiner">
              <div
                class="left-panel-heading moa-heading-truncate"
                title="Mechanism of action"
              >
                <span>Mechanism of action</span>
                <va-icon
                  *ngIf="data.data.moa.length > 0"
                  isFontAwesome="true"
                  [name]="faFileSearch"
                  [class]="
                    auditIconVisible.moa
                      ? 'formula-icon'
                      : 'formula-icon-disabled'
                  "
                  (click)="auditSource({}, 'moa', true)"
                  [title]="
                    auditIconVisible.moa
                      ? 'Audit Source'
                      : 'Source Not Available'
                  "
                ></va-icon>
              </div>
            </div>
            <ng-container *ngIf="data.data.moa.length > 0">
              <div *ngFor="let item of data.data.moa; let i = index">
                <div
                  *ngIf="i < 3"
                  style="
                    padding-bottom: 8px;
                    display: flex;
                    align-items: center;
                  "
                  title="{{ item }}"
                >
                  <span class="sub-headings moa-truncate">
                    {{ item }}
                  </span>
                  <span
                    *ngIf="
                      data.data.moa.length > 0 &&
                      i == 2 &&
                      data.data.moa.length > 3
                    "
                    style="margin-top: 4px; text-wrap: nowrap"
                  >
                    <span
                      nz-dropdown
                      nzTrigger="click"
                      [nzDropdownMenu]="moaMenu"
                      (nzVisibleChange)="onMoaVisibleChange($event)"
                      [nzBackdrop]="false"
                    >
                      <va-icon
                        *ngIf="moaDataVisible; else expand"
                        size="small"
                        name="collapse-arrows"
                        style="margin-left: 4px"
                      ></va-icon>
                      <ng-template #expand>
                        <va-icon
                          size="small"
                          name="expand-arrows"
                          style="margin-left: 4px"
                        ></va-icon>
                      </ng-template>
                    </span>

                    <span *ngIf="data.data.moa.length > 3">
                      (+{{ data.data.moa.length - 3 }})
                    </span>
                    <nz-dropdown-menu #moaMenu="nzDropdownMenu">
                      <ul class="custom-dropdown" nz-menu>
                        <li
                          *ngFor="let item of data.data.moa.slice(3)"
                          nz-menu-item
                          class="defaultCursor dropdown-items"
                        >
                          <div class="sub-headings truncate">
                            {{ item }}
                          </div>
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </span>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="divider"></div>
          <div id="target">
            <div class="target-conatiner">
              <div
                class="left-panel-heading target-heading-truncate"
                title="Target"
              >
                <span>Target</span>
                <va-icon
                  *ngIf="data.data.moa.length > 0"
                  isFontAwesome="true"
                  [name]="faFileSearch"
                  [class]="
                    auditIconVisible.target
                      ? 'formula-icon'
                      : 'formula-icon-disabled'
                  "
                  (click)="auditSource({}, 'target', true)"
                  [title]="
                    auditIconVisible.target
                      ? 'Audit Source'
                      : 'Source Not Available'
                  "
                ></va-icon>
              </div>
            </div>
            <div *ngIf="data.data.target.length === 0">
              <span> - </span>
            </div>
            <ng-container *ngIf="data.data.target.length > 0">
              <div *ngFor="let item of data.data.target; let i = index">
                <div
                  *ngIf="i < 3"
                  style="padding-bottom: 8px"
                  title="{{ item }}"
                  nz-row
                >
                  <span
                    nz-col
                    class="target-truncate"
                    [ngClass]="{ 'target-truncate-heading-with-count': i == 2 }"
                  >
                    {{ item }}
                  </span>
                  <span nz-col style="display: flex; align-items: center">
                    <span
                      *ngIf="
                        data.data.target.length > 0 &&
                        i == 2 &&
                        data.data.target.length > 3
                      "
                      style="margin-top: 4px; text-wrap: nowrap"
                    >
                      <span
                        nz-dropdown
                        nzTrigger="click"
                        [nzDropdownMenu]="targetMenu"
                        (nzVisibleChange)="onTargetVisibleChange($event)"
                        [nzBackdrop]="false"
                      >
                        <va-icon
                          *ngIf="targetDataVisible; else expand"
                          size="small"
                          name="collapse-arrows"
                          style="margin-left: 4px"
                        ></va-icon>
                        <ng-template #expand>
                          <va-icon
                            size="small"
                            name="expand-arrows"
                            style="margin-left: 4px"
                          ></va-icon>
                        </ng-template>
                      </span>

                      <nz-dropdown-menu #targetMenu="nzDropdownMenu">
                        <ul class="custom-dropdown" nz-menu>
                          <li
                            *ngFor="let item of data.data.target.slice(3)"
                            nz-menu-item
                            class="defaultCursor dropdown-items"
                          >
                            <div class="truncate">
                              {{ item }}
                            </div>
                          </li>
                        </ul>
                      </nz-dropdown-menu>
                    </span>
                    <span
                      *ngIf="
                        data.data.target.length > 3 &&
                        data.data.target.length > 0 &&
                        i == 2
                      "
                    >
                      (+{{ data.data.target.length - 3 }})
                    </span>
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #failure>
    <div nz-row nzType="flex">Failure</div>
  </ng-template>

  <ng-template #error>
    <div nz-row nzType="flex">Error</div>
  </ng-template>
</div>
